import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { api } from '../api/client.js';
import { login } from '../services/auth.js';

// Login view. Handles credentials, surfaces backend errors, and redirects
// the visitor to wherever they were headed before being gated.
export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [consent, setConsent] = useState(null);
  const [accepted, setAccepted] = useState({ terms: false, privacy: false });

  const from = (location.state?.from?.pathname) || '/dashboard';

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      await login(username, password, consent !== null);
      navigate(from, { replace: true });
    } catch (err) {
      if (err.message === 'Consent required' && consent === null) {
        try {
          const { data } = await api.get('/auth/consent/documents');
          setConsent(data.data);
          setSubmitting(false);
          return;
        } catch (documentError) {
          setError(documentError.message || 'Texty se nepodařilo načíst.');
          setSubmitting(false);
          return;
        }
      }
      setError(err.message || 'Přihlášení se nezdařilo');
      setSubmitting(false);
    }
  };

  return (
    <div className="auth">
      <h1 className="auth__title">Přihlášení</h1>
      <p className="auth__subtitle">Přihlaste se do svého účtu Drill.</p>

      {consent && (
        <section aria-label="Aktualizované podmínky">
          <h2>Aktualizované podmínky</h2>
          {consent.documents.map((document) => (
            <details key={document.key}>
              <summary>{document.title}</summary>
              <p>{document.text}</p>
            </details>
          ))}
          {consent.checks.map((check) => (
            <label className="auth__label" key={check.key}>
              <span>
                <input
                  type="checkbox"
                  checked={accepted[check.key] || false}
                  onChange={(event) => setAccepted((current) => ({
                    ...current,
                    [check.key]: event.target.checked,
                  }))}
                />{' '}
                {check.label}
              </span>
              <small>{check.hint}</small>
            </label>
          ))}
        </section>
      )}

      <form className="auth__form" onSubmit={handleSubmit}>
        <label className="auth__label">
          Uživatelské jméno správce / e-mail makléře
          <input
            className="auth__input"
            type="text"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            autoComplete="username"
            required
          />
        </label>

        <label className="auth__label">
          Heslo
          <input
            className="auth__input"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {error && <p className="auth__error" role="alert">{error}</p>}

        <button
          className="button button--primary"
          type="submit"
          disabled={submitting || (consent !== null && (!accepted.terms || !accepted.privacy))}
        >
          Přihlásit se
        </button>
      </form>

      <p className="auth__alt">
        <a href="/mobile/">Makléř: přihlásit se odkazem z e-mailu</a>
      </p>
      <p className="auth__alt">
        Nemáte účet? Obraťte se na JR, který vám připraví účet a pošle pozvánku.
      </p>
      <p className="auth__alt">
        <Link to="/forgot-password">Zapomněli jste heslo?</Link>
      </p>
    </div>
  );
}
